/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Preview_Vehicle_Number_DescriptionInputs */

const fr_settings_preview_vehicle_number_description = /** @type {(inputs: Settings_Preview_Vehicle_Number_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prévisualiser le numéro de véhicule lors du zoom sur un point de la carte.`)
};

const en_settings_preview_vehicle_number_description = /** @type {(inputs: Settings_Preview_Vehicle_Number_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview the vehicle number when zooming on a map point.`)
};

/**
* | output |
* | --- |
* | "Preview the vehicle number when zooming on a map point." |
*
* @param {Settings_Preview_Vehicle_Number_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_preview_vehicle_number_description = /** @type {((inputs?: Settings_Preview_Vehicle_Number_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Preview_Vehicle_Number_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_preview_vehicle_number_description(inputs)
	return en_settings_preview_vehicle_number_description(inputs)
});